import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ShopContextProvider  from './Context/ShopContext';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ShopContextProvider>
    <App />
  </ShopContextProvider>
);

reportWebVitals();
